import ICONS from './app-icons.js';

// 앱 아이콘 — 이모지 대신 쓴다. 글자 크기(1em)와 글자색(currentColor)을 따른다.
// <AppIcon name="home" />                        장식(옆에 글자가 있음) — 화면 읽기 프로그램은 건너뛴다
// <AppIcon name="alert-triangle" label="경고" />  아이콘만으로 뜻을 전할 때는 label 을 준다
export default {
    name: 'AppIcon',
    functional: true,
    props: {
        name: { type: String, required: true },
        label: { type: String, default: '' },
    },
    render(h, { props, data }) {
        const body = ICONS[props.name];
        if (!body) throw new Error(`AppIcon: 없는 아이콘 "${props.name}" — packages/shared/components/common/app-icons.js 에 추가`);
        return h('svg', {
            ...data,
            class: ['app-icon', data.class],
            attrs: {
                xmlns: 'http://www.w3.org/2000/svg',
                viewBox: '0 0 24 24',
                fill: 'none',
                stroke: 'currentColor',
                'stroke-width': 2,
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
                focusable: 'false',
                ...(props.label ? { role: 'img', 'aria-label': props.label } : { 'aria-hidden': 'true' }),
                ...data.attrs,
            },
            // 저장소 안의 고정 SVG 경로만 넣는다(사용자 입력 아님)
            domProps: { innerHTML: body },
        });
    },
};
